import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import Ovr from '@/views/Ovr/Ovr.vue'
import Login from '@/views/login/login.vue'
import Home from '@/views/Ovr/home/home.vue'
import Propose from '@/views/Ovr/propose/propose.vue'
import Join from '@/views/Ovr/join/join.vue'
import Profile from '@/views/Ovr/profile/profile.vue'


const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Ovr',
    component: Ovr,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: '/propose',
        name: 'Propose',
        component: Propose
      },
      {
        path: '/join',
        name: 'Join',
        component: Join
      }
    ]
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  history: true,
  routes
})

// Check auth before each routes
router.beforeEach((to, from, next) => {
  let currentUser = null
  firebase.auth().onAuthStateChanged(function (user) {
    currentUser = user
    if (!currentUser && to.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js